import React from 'react';
import { useRouter } from 'next/router';
import { useGetUrl } from '@separate/hooks/getUrl';
import { useIsSingleSigningOn } from '@separate/hooks/singleSignOn';
import { useLocale } from '@separate/hooks/translation';
import { useCurrentUser } from '@separate/hooks/user';
import { logEvent, logPageView, SSO_SUCCESSFUL } from '@separate/utilities/analytics';
import { compact } from '@separate/utilities/object';
import { getUtmTags } from '@separate/utilities/utmTagsStore';

export const useLogSSOSuccessful = () => {
  const { user, isLoggedIn } = useCurrentUser();
  const locale = useLocale();
  const { canonicalUrl } = useGetUrl();
  const { hasSingleSignedOn } = useIsSingleSigningOn();
  const pid = user?.pid

  const [hasLoggedEvent, setHasLoggedEvent] = React.useState(false);

  React.useEffect(() => {
    if (isLoggedIn) return;

    setHasLoggedEvent(false);
  }, [isLoggedIn]);

  React.useEffect(() => {
    if (!hasSingleSignedOn || hasLoggedEvent) return;

    logEvent(SSO_SUCCESSFUL, compact({
      source: 'web',
      pid,
      utm_parameters: getUtmTags(),
      language: locale,
      source_url: canonicalUrl,
    }));

    setHasLoggedEvent(true);
  }, [hasSingleSignedOn, hasLoggedEvent, pid, locale, canonicalUrl]);
};

export function useSetWelcomeTechReferrer() {
  const router = useRouter();

  React.useEffect(() => {
    function setWelcomeTechReferrer() {
      window.WelcomeTech = window.WelcomeTech || {};
      window.WelcomeTech.referrer = location.href;
    }

    router.events.on('routeChangeStart', setWelcomeTechReferrer);

    return () => {
      router.events.off('routeChangeStart', setWelcomeTechReferrer);
    };
  }, [router.events]);
}

export function useLogPageView() {
  useSetWelcomeTechReferrer();
  const utmTags = getUtmTags();

  React.useEffect(() => {
    if (!utmTags) return; // wait for tags to resolve; {} is true

    logPageView(utmTags);
  }, [utmTags]);
}
